import React from 'react';
import TextComponent from 'shared/components/TextComponent';

const GoldFingers = (props) => {
  const name = 'gold_fingers';
  const {
    parameters,
    errorMessage,
    label,
    inputId,
    required,
    onChangeParameter,
    groupName,
    tooltip,
    className,
    inputClassName,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label={label}
      name={name}
      inputId={inputId}
      type="number"
      value={parameters[name] || ''}
      required={required}
      groupName={groupName}
      onChange={onChange}
      tooltip={tooltip}
      className={className}
      inputClassName={inputClassName}
      errorMessage={errorMessage}
      disabled={disabled} />
  );
};

GoldFingers.defaultProps = {
  label: Spree.translations.parameters.gold_fingers,
  tooltip: Spree.helpForParameters.gold_fingers,
};

export default GoldFingers;
